var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrgGroupIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    strokeOpacity: 0.34,
    stroke: "#91919C",
    fill: "#FFF",
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.545 21.09H24v1.455H8v-1.454h1.455V8.727c0-.401.325-.727.727-.727h11.636c.402 0 .727.326.727.727v12.364zm-1.454 0V9.456H10.909V21.09h10.182zm-8-6.545h2.182V16H13.09v-1.455zm0-2.909h2.182v1.455H13.09v-1.455zm0 5.819h2.182v1.454H13.09v-1.454zm3.636 0h2.182v1.454h-2.182v-1.454zm0-2.91h2.182V16h-2.182v-1.455zm0-2.909h2.182v1.455h-2.182v-1.455z",
    fill: "#91919C",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgGroupIcon);
export default __webpack_public_path__ + "static/media/org-group-icon.2a0494a5d078f8ca70a3e3a65838a10c.svg";
export { ForwardRef as ReactComponent };